module.exports = __webpack_public_path__ + "media/images/lb/952-9c2baf01664d44906eede1be1a0c28cc.svg";